import React, { useEffect, useState } from 'react';
import { Stage, Component } from 'react-ngl';
import { Typography } from '@mui/material';
import fire from '../../../3rd-party-config/fire';

const Visualizer = ({ width, height, path, stem, bgcolor, position }) => {
  const [pathWithToken, setPathWithToken] = useState(path);

  const defaultReprParams = {
    radiusScale: 0.5,
    aspectRatio: 5,
    quality: 'auto',
    multipleBond: "symmetric"
  };

  useEffect(() => {
    let mounted = true;
    const withToken = async () => {
      const user = fire.auth().currentUser;
      if (!user) {
        if (mounted) setPathWithToken(path);
        return;
      }
      const token = await user.getIdToken();
      const sep = path.includes('?') ? '&' : '?';
      if (mounted) setPathWithToken(`${path}${sep}authToken=${encodeURIComponent(token)}`);
    };
    withToken();
    return () => {
      mounted = false;
    };
  }, [path]);

  return (
    <div>
      <Typography
        variant='h5'
        align="center"
        color='textSecondary'
        style={{ wordWrap: "break-word", wordBreak: 'break-all' }}
      >
        {stem}
      </Typography>

      <Stage
        width={width}
        height={height}
        params={{ backgroundColor: bgcolor }}
      >
        <Component
          path={pathWithToken}
          reprList={[{ type: 'ball+stick', params: defaultReprParams }]}
          position={[-position[0], -position[1], -position[2]]}
          scale={2.5}
        />
      </Stage>
    </div>
  );
};

export default Visualizer;
